var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 9,
    viewBox: "0 0 8 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.87455 6.0556L6.87186 4.10577L8 5.17127L4.00148 9L-3.35371e-07 5.1638L1.0791 4.12444L3.08521 6.07988L3.1647 6.05002C3.17156 5.95197 3.18332 5.8539 3.18332 5.75492C3.18332 3.93861 3.18332 2.12231 3.18332 0.305995C3.18332 0.0772061 3.23924 -0.0133653 3.49332 0.00157586C3.83672 0.0202516 4.18095 0.0202516 4.52434 0.00157577C4.76272 -0.0105636 4.81863 0.073457 4.81863 0.291974C4.81078 2.09895 4.81863 3.90592 4.81863 5.71382L4.81863 6.03041L4.87455 6.0556Z",
    fill: "black",
    fillOpacity: 0.65
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortArrowDown);
export default __webpack_public_path__ + "static/media/sort-arrow-down.137fdb577056554cbe8e5fa40e2f1437.svg";
export { ForwardRef as ReactComponent };